<script lang="ts">
  import { goto } from '$app/navigation';
  import { acceptResearchConsent, leaderboardOptIn } from '$lib/api/studentActions';
  import { auth } from '$lib/stores/auth.svelte';
  import { faArrowRight } from '@itdev-fortawesome/pro-solid-svg-icons/faArrowRight';
  import { FontAwesomeIcon } from '@fortawesome/svelte-fontawesome';
  import { fly } from 'svelte/transition';

  if (auth.user?.role !== 'student') {
    goto('/', { replaceState: true });
  }

  if (auth.user?.acceptedResearchConsent) {
    goto('/', { replaceState: true });
  }

  let researchConsent = $state(false);
</script>

<main id="main-content" class="container py-3 transition-container">
  {#key researchConsent}
    <div class="narrow" in:fly={{ x: 300 }} out:fly={{ x: -300 }} aria-live="polite">
      {#if !researchConsent}
        <h2>Welcome to the OB clinical skills game!</h2>
        <p>
          This game is designed to support your learning and boost engagement during clinical. You will log in using
          your UAMS credentials, and your participation will link to your UAMS ID. We will track your activity only for
          the purpose of monitoring game participation. Your performance in the game will not impact your clinical
          grade. Have fun competing with your classmates and building your clinical confidence!
        </p>
        <div class="d-grid">
          <button
            class="btn btn-primary"
            onclick={async () => {
              acceptResearchConsent();
              auth.acceptResearchConsent();
              if (auth.user?.redirectClassId !== undefined) {
                researchConsent = true;
                return;
              }

              goto('/', { replaceState: true });
            }}
          >
            Accept and Continue <FontAwesomeIcon icon={faArrowRight} class="ms-2" />
          </button>
        </div>
      {:else}
        <h2>Participate in Class Leaderboards?</h2>
        <p>
          Earn points and compete with the rest of your class. Your rank and score will be shared with the rest of the
          class if you rank in the top 10 places. Participation is not required. Not participating in the leaderboard
          does not affect your grade. You can opt in or out at any time.
        </p>
        <div class="grid-2-cols mt-5">
          <button
            class="btn btn-primary"
            onclick={() => {
              leaderboardOptIn(auth.user!.redirectClassId!);
              goto(`/classes/${auth.user!.redirectClassId}`, { replaceState: true });
            }}
          >
            Yes
          </button>
          <button
            class="btn btn-primary"
            onclick={() => {
              goto(`/classes/${auth.user!.redirectClassId}`, { replaceState: true });
            }}
          >
            Not now
          </button>
        </div>
      {/if}
    </div>
  {/key}
</main>

<style>
  .transition-container {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
  }

  .transition-container > * {
    grid-row: 1;
    grid-column: 1;
  }
</style>
